import React from 'react';
import { Pool } from '../types';
import { formatters } from '../services/api';
import './HorizontalCoinList.css';

interface HorizontalCoinListProps {
  pools: Pool[];
}

const HorizontalCoinList: React.FC<HorizontalCoinListProps> = ({ pools }) => {
  const getCoinTicker = (pool: Pool) => {
    if (pool.coinSymbol) return pool.coinSymbol.toUpperCase();
    if (pool.coin) {
      const compact = pool.coin.replace(/[^a-z0-9]/gi, '').slice(0, 4);
      return compact ? compact.toUpperCase() : pool.coin.charAt(0).toUpperCase();
    }
    return '';
  };

  const getCoinLogo = (pool: Pool) => {
    const candidates: string[] = [];
    if (pool.coinSymbol) {
      candidates.push(pool.coinSymbol.toLowerCase());
    }
    if (pool.coin) {
      candidates.push(pool.coin.toLowerCase().replace(/\s+/g, ''));
    }
    const uniqueCandidates = Array.from(new Set(candidates.filter(Boolean)));
    if (!uniqueCandidates.length) return null;
    return `/images/coins/${uniqueCandidates[0]}.png`;
  };

  const handleConnectClick = (poolId: string) => {
    sessionStorage.setItem('connectPool', poolId);
    window.location.hash = '#connect';
  };

  return (
    <div className="coin-table-list">
      <table className="coins-table">
        <thead>
          <tr>
            <th>Coin</th>
            <th>Payment Scheme</th>
            <th>Algorithm</th>
            <th>Pool Fee</th>
            <th>Pool Hashrate</th>
            <th>Network Hashrate</th>
            <th>Miners</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {pools.map(pool => (
              <tr key={pool.id} className="coin-table-row">
                <td className="coin-info-cell">
                  <div className="coin-info">
                    {(() => {
                      const ticker = getCoinTicker(pool);
                      const fallbackSymbol = ticker.charAt(0) || pool.coin.charAt(0) || '?';
                      const logo = getCoinLogo(pool);
                      return (
                        <div className="coin-logo-wrapper" data-symbol={fallbackSymbol}>
                          {logo ? (
                            <img
                              src={logo}
                              alt={`${pool.coin} logo`}
                              className="coin-logo"
                              onError={(event) => {
                                event.currentTarget.style.display = 'none';
                                const parent = event.currentTarget.parentElement;
                                if (parent) parent.classList.add('coin-logo-fallback');
                              }}
                            />
                          ) : (
                            <span className="coin-logo-symbol">{fallbackSymbol}</span>
                          )}
                        </div>
                      );
                    })()}
                    <div className="coin-meta">
                      <div className="coin-name">{pool.coin}</div>
                      <div className="coin-ticker">{getCoinTicker(pool)}</div>
                    </div>
                  </div>
                </td>
                <td className="payment-scheme-cell">
                  <span className="payment-scheme">{pool.paymentType || 'SOLO'}</span>
                </td>
                <td className="algorithm-cell">
                  <span className="algorithm-badge">{pool.algorithm}</span>
                </td>
                <td className="stat-cell">
                  {typeof pool.fee === 'number' ? `${pool.fee}%` : '—'}
                </td>
                <td className="stat-cell">
                  {formatters.hashrate(pool.hashrate)}
                </td>
                <td className="stat-cell">
                  {pool.stats?.networkhashrate 
                    ? formatters.hashrate(pool.stats.networkhashrate)
                    : 'Unknown'
                  }
                </td>
                <td className="stat-cell">
                  {pool.minerCount}
                </td>
                <td className="connect-cell">
                  <button
                    className="connect-btn"
                    onClick={() => handleConnectClick(pool.id)}
                    type="button"
                  >
                    Connect
                  </button>
                </td>
              </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default HorizontalCoinList;
